module.exports = __webpack_public_path__ + "img/source-code-pro-light.70f56206.png";